<!-- 倒计时按钮的组件 -->
<template>
  <div class="zws-count">
    <el-button type="primary" @click="onClickSmsCode" :disabled="disabledSendCode" class="getCode">{{ !disabledSendCode ? '获取验证码' : "重新发送" + '(' + disabledCount + ')'}}</el-button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    validateFlag: {
      type: Boolean
    },
    isZWS: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    validateFlag (newVal, oldVal) {
      if (newVal) {
        this.onClickSmsCode()
      }
    }
  },
  data () {
    return {
      disabledSendCode: false,
      disabledCount: 0,
      textSendCode: this.text || '获取验证码',
      count: true
    }
  },
  methods: {
    onClickSmsCode () {
      this.$emit('onClickSmsCode')
      if (!this.validateFlag) {
        return
      }
      this.count = true
      this.$emit('count', this.count)
      this.disabledSendCode = true
      this.disabledCount = 60
      this.intervalNumber = setInterval(() => {
        this.disabledCount--
        if (this.disabledCount === 0) {
          clearInterval(this.intervalNumber)
          this.$emit('count', !this.count)
          this.disabledSendCode = false
        } else {
          this.textSendCode += `(${this.disabledCount})`
        }
      }, 1000)
    }
  }
}
</script>
<style lang='less' scoped>
.count-down {
  .gain-code {
    width: 140px;
    border-color: #c0c4cc;
    font-size: 14px;
    text-align: center;
    color: #303133;
    background-color: #fff;
  }
}
.zws-count {
  .getCode {
    width: 125px;
    //  border-color: #43a8f8;
    background-color: #103a5e;
  }
  .gain-code {
    width: 92px;
    background-color: #0f3a5c;
    border-color: #43a8f8;
    font-size: 14px;
    color: #fff;
    position: relative;
    &:hover {
      background-color: #2196f3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/Common/ZWSComponent/CountDown.vue